export const othersData = [
    {
        performanceProgress: 'ปริมาณขาย',
        quantity: 'ตัน',
        January: '8,083',
        February: '8,027',
        March: '8,030',
        April: '8,539',
        May: '7,969',
        June: '7,893',
        July: '8,486',
        August: '8,346',
        September: '7,758',
        October: '9,040',
        November: '8,571',
        December: '9,274',
        total: '100,018',
    },
    {
        performanceProgress: 'มูลค่าขาย',
        quantity: 'ล้านบาท',
        January: '120',
        February: '117',
        March: '121',
        April: '132',
        May: '126',
        June: '128',
        July: '140',
        August: '140',
        September: '133',
        October: '154',
        November: '147',
        December: '159',
        total: '1,619',
    },
    {
        performanceProgress: 'ราคาขาย',
        quantity: 'บาท/ก.ก.',
        January: '14.8',
        February: '14.6',
        March: '15.1',
        April: '15.5',
        May: '15.9',
        June: '16.3',
        July: '16.5',
        August: '16.8',
        September: '17.1',
        October: '17.0',
        November: '17.1',
        December: '17.2',
        total: '16.2',
    },
    {
        performanceProgress: 'ต้นทุนรวม',
        quantity: 'บาท/ก.ก.',
        January: '(12.9)',
        February: '(12.8)',
        March: '(12.9)',
        April: '(14.1)',
        May: '(13.8)',
        June: '(14.6)',
        July: '(15.4)',
        August: '(15.2)',
        September: '(15.2)',
        October: '(16.0)',
        November: '(14.9)',
        December: '(15.4)',
        total: '(14.5)',
    },
    {
        performanceProgress: 'กำไรสุทธิ',
        quantity: 'บาท/ก.ก.',
        January: '1.9',
        February: '1.8',
        March: '2.2',
        April: '1.4',
        May: '2.1',
        June: '1.6',
        July: '1.1',
        August: '1.6',
        September: '1.9',
        October: '1.0',
        November: '2.2',
        December: '1.8',
        total: '1.7',
    },
    {
        performanceProgress: '',
        quantity: 'ล้านบาท',
        January: '15',
        February: '14',
        March: '18',
        April: '12',
        May: '16',
        June: '13',
        July: '9',
        August: '13',
        September: '15',
        October: '9',
        November: '19',
        December: '17',
        total: '172',
    },
    {
        performanceProgress: '',
        quantity: '%',
        January: '12.6%',
        February: '12.2%',
        March: '14.8%',
        April: '9.3%',
        May: '13.0%',
        June: '10.0%',
        July: '6.7%',
        August: '9.6%',
        September: '11.1%',
        October: '6.1%',
        November: '12.9%',
        December: '10.7%',
        total: '10.6%',
    },
]